import {UndoableAction} from "../common/UndoableAction";
import {WorkspaceModelType} from "../../stores/WorkspaceStore";
import {updateItemChildIdsSet} from "./updateItem";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { DataSourceManager } from "../../stores/dataSources/DataSourceManager";


export class UpdateItemChildIdsSet implements UndoableAction {
    private services: CrudServices;
    private dsManager: DataSourceManager;
    targetId: string;
    childIds: string[];
    oldChildIds: string[];
    workspace: WorkspaceModelType;
    dbQueue?: Promise<any>;

    constructor(
        services: CrudServices,
        dsManager: DataSourceManager,
        targetId: string,
        childIds: string[],
        workspace: WorkspaceModelType,
        dbQueue?: Promise<any>
        ) {
        this.services = services;
        this.dsManager = dsManager;
        this.targetId = targetId;
        this.childIds = childIds;
        this.workspace = workspace;
        this.dbQueue = dbQueue;
        this.oldChildIds = workspace.items.get(this.targetId)!.childIds.toJSON()
    }
    execute(): Promise<any> {
        return updateItemChildIdsSet(this.services, this.dsManager, this.targetId, this.childIds, this.workspace, this.dbQueue);
    }
    undo(): Promise<any> {
        return updateItemChildIdsSet(this.services, this.dsManager, this.targetId, this.oldChildIds, this.workspace);
    }
}
